<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left" *ngIf="type == 'ADDUSERS'"> {{'addEmployees' | translate}} </h5>
        <h5 class="medium float-left" *ngIf="type == 'DELETEUSERS'"> {{'removeEmp' | translate}} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary float-right mb-2" name="backToUserG" (click)="rolesBack()"><i
                class="fa fa-arrow-left mr-sm-2"></i>{{'back' | translate}}
        </button>
    </div>

    <div class="w-100 float-left my-4" *ngIf="type == 'ADDUSERS'">
        <h6 class="medium mb-3"> {{'chooseEmpAdd' | translate}} </h6>
        <div class="form-group col-lg-3 col-md-3 float-left" (click)="selectOption('everyone')">
            <input type="radio" id="everyone" name="radio-group" checked>
            <label for="everyone" class="normal"> {{'includeEveryOne' | translate}} </label>
        </div>

        <div class="form-group col-lg-3 col-md-3 float-left" (click)="selectOption('except')">
            <input type="radio" id="except" name="radio-group">
            <label for="except" class="normal"> {{'includeEveryOneExpect' | translate}} </label>
        </div>

        <div class="form-group col-lg-3 col-md-3 float-left" (click)="selectOption('everyoneIn')">
            <input type="radio" id="everyonein" name="radio-group">
            <label for="everyonein" class="normal"> {{'includeEveryoneIn' | translate}} </label>
        </div>
        <div class="col-lg-10 col-md-10 float-left mb-2" *ngIf="selectedOption != 'everyone'">
            <p class="text-primary float-right pl-3 m-0 cursor" (click)="showAdvanced()"
               *ngIf="selectedOption === 'everyoneIn'">
                {{'doNotEmpCode' | translate}}</p>
            <textarea class="form-control w-100" rows="5" name="empCodeUG" [(ngModel)]="empCodes"></textarea>
            <span class="text-12x"> {{'enterEmpCodeWithSeparator' | translate}} </span>
        </div>
        <div class="w-100 float-left mt-3" *ngIf="invalidEmployeeCodes.length > 0">
            <label>{{'invalidEmpCodes' | translate}}</label>
            <p class="text-danger  rounded p-2" [innerHTML]="invalidEmployeeCodes"></p>
        </div>
    </div>

    <div class="w-100 float-left my-4" *ngIf="type == 'DELETEUSERS'">
        <h6 class="medium mb-3"> {{'chooseToRemove' | translate}} </h6>

        <div class="col-lg-10 col-md-10 float-left mb-2">
            <textarea class="form-control w-100" rows="5" name="removeEmpCodeUG" [(ngModel)]="empCodes"></textarea>
            <span class="text-12x"> {{'enterEmpCodeWithSeparator' | translate}} </span>
        </div>
        <div class="w-100 float-left mt-3 ">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-center">
                    <h6 class="mb-lg-0 medium"> {{'includedList' | translate}} </h6>
                </div>
            </div>
        </div>
        <!-- EMPLOYEE DETAILS GRID -->
        <div class="w-100 float-left mt-3">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div class="checkbox checkbox-primary">
                        <input id="self" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll($event)">
                        <label for="self" class="mb-0"></label>
                    </div>
                </div> -->
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'code' | translate}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'email' | translate}} </h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'userName' | translate}} </h6>
                </div>
            </div>
            <ng-container *ngIf="employeeData.length != 0">
                <div class="w-100 float-left p-md-2 grid-details" *ngFor="let employee of employeeData;index as i">
                    <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                        <div class="checkbox checkbox-primary">
                            <input id="id_{{employee.userId}}" type="checkbox" [(ngModel)]="employee.selected" (change)="checkIfAllSelected(employee,$event)">
                            <label for="id_{{employee.userId}}" class="mb-0"></label>
                        </div>
                    </div> -->
                    <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate"> {{employee.employeeCode}} </h6>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate"> {{employee.employeeName}} </h6>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate"> {{employee.email}} </h6>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate"> {{employee.userName}} </h6>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="employeeData.length == 0">
                <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                    <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
      
                        <img src="./assets/img/load.gif" alt="loading" width="80px">
                    
                </div> -->
                    <div class="loader-div">
                        <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                        <div class="loader-gif"></div>
                    </div>
                </div>
                <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                    <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
                </div>
            </ng-container>

        </div>
        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()"
             *ngIf="employeeData.length> 0">
            <h6 class="float-left mb-0"> {{((searchData.page-1)*searchData.pageSize)+1}} -
                {{searchData.pageSize*(searchData.page-1)+employeePageData.numberOfElements}}
                {{'itemsOf' | translate}} {{employeePageData.totalElements}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" name="pageSizeAddUTG"
                        [(ngModel)]="searchData.pageSize"
                        (change)="onPageSizeChange()">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="employeePageData.totalElements" [maxSize]="5" [rotate]="true"
                            [pageSize]="searchData.pageSize" [ellipses]="false"
                            [(page)]="searchData.page" [boundaryLinks]="true" (pageChange)="getEmployeeDetails()"
                            class="float-right"></ngb-pagination>
        </div>


    </div>
    <button class="btn btn-primary float-right" *ngIf="type == 'ADDUSERS'" name="addEmpUTG" (click)="addUsers()"
            [disabled]="disableButton">{{'add' | translate}}
    </button>
    <button class="btn btn-primary float-right" *ngIf="type == 'DELETEUSERS'" name="deleteEmpUTG"
            (click)="removeUsers()" [disabled]="disableButton">{{'remove' | translate}}
    </button>
    <button class="btn btn-secondary float-right mr-4" name="cancelInUTG" (click)="rolesBack()">{{'cancel' |
        translate}}
    </button>


// WEBPACK FOOTER //
// ./src/app/tools/userGroup/addUsersToGroup.html